import styled from '@emotion/styled/macro'
import { Box, Breadcrumbs as MuiBreadcrumbs } from '@mui/material'
import theme from 'theme'

export const Container = styled(Box)`
  width: 100%;
  height: 100%;
  min-height: 100vh;
  background: ${theme.colors.analyzerPanelDarker};

  html[data-theme='light'] & {
    background: ${theme.colors.pageBackground};
  }
`

export const Breadcrumbs = styled(MuiBreadcrumbs)<{ isdisabled?: string }>`
  ${({ isdisabled }) =>
    isdisabled &&
    isdisabled === 'true' &&
    `
      cursor: default;
      pointer-events: none;
  `};

  .MuiBreadcrumbs-li {
    color: ${theme.colors.foreground};
    font-family: ${theme.typography.fontFamily.primary};
    font-size: ${theme.typography.fontSize.xxxxLarge};
    font-style: normal;
    font-weight: ${theme.typography.fontWeight.normal};
    line-height: 36px;
    text-transform: capitalize;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .MuiBreadcrumbs-separator {
    color: ${theme.colors.cta};
    margin-left: ${theme.spacing.sm}px;
    margin-right: ${theme.spacing.sm}px;
  }
`

export const Content = styled(Box)`
  display: flex;
  padding: ${theme.spacing.medium}px;
  width: 100%;
  flex-basis: 100%;
  gap: ${theme.spacing.medium}px;
`

export const SectionDivider = styled(Box)<{ height: string }>`
  background: ${theme.colors.legacyBorderLow2};
  width: 1px;
  height: ${({ height }) => height};
  align-self: flex-end;
  margin-left: ${theme.spacing.sm}px;
  margin-top: 50px;
`

export const paperPropsSx = {
  sx: {
    background: theme.colors.cardFillTertiary,
    border: `1px solid ${theme.colors.strokePrimary}`,
    borderRadius: theme.attributes.borderRadius.small,
    padding: `${theme.spacing.xSmall}px`,
    maxHeight: 40 * 4.5,
    marginTop: `${theme.spacing.half}px`,
    width: '225px',
    boxSizing: 'border-box',
    height: '56px',
    overflowY: 'hidden',

    '.MuiList-root': {
      padding: 0,

      '.MuiMenuItem-root': {
        height: '40px',
        background: 'transparent',

        '&:hover': {
          background: theme.colors.tooltipBg
        },

        '&.disabled-menu': {
          color: theme.colors.caption,

          '&:hover': {
            cursor: 'default',
            background: 'transparent'
          }
        },

        borderRadius: theme.attributes.borderRadius.small,
        overflow: 'hidden',
        color: theme.colors.foreground,
        textOverflow: 'ellipsis',
        fontFamily: theme.typography.fontFamily.primary,
        fontSize: theme.typography.fontSize.xLarge,
        fontStyle: 'normal',
        fontWeight: theme.typography.fontWeight.normal,
        lineHeight: 'normal'
      }
    }
  }
}

export const customFrameworkMenuPaperProps = {
  sx: {
    background: theme.colors.menuBg,
    boxShadow: theme.colors.tooltipShadow,
    padding: 0,
    borderRadius: '12px',
    marginTop: '13px',
    width: '244px',
    boxSizing: 'border-box',
    overflow: 'hidden',

    '.MuiList-root': {
      padding: 0,
      borderRadius: '12px',

      '.MuiMenuItem-root': {
        background: theme.colors.menuBg,
        height: '48px',
        color: theme.colors.menuItemText,
        fontFamily: theme.typography.fontFamily.primary,
        fontSize: '14px',
        fontStyle: 'normal',
        fontWeight: 500,
        lineHeight: '22px',

        '&:first-of-type': {
          padding: '16px 16px 10px 16px'
        },

        '&:last-of-type': {
          padding: '10px 16px 16px 16px'
        },

        '&:hover': {
          background: theme.colors.menuItemHover
        },

        '&.disabled-menu': {
          color: theme.colors.caption,

          '&:hover': {
            cursor: 'default',
            background: theme.colors.menuItemHover
          }
        }
      }
    }
  }
}
